import React from 'react'
import { BrowserRouter, Route, Routes as Switch } from 'react-router-dom'
import Home from './components/Home/home'
import Generate from './components/Generate/Generate'

export default function Routes() {
    return (
        <>
            <BrowserRouter>
                {/* <Header /> */}
                <Switch>
                    <Route path='/' element={<Home />} />
                    <Route path='/generate' element={<Generate />} />
                </Switch>
                {/* <Footer /> */}
            </BrowserRouter>

        </>
    )
}
